import { format } from 'date-fns';

export const formattedDate = (
  dateString: string | null | undefined,
): string => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return format(date, 'MMM dd, yyyy');
};
